import { defineStore } from 'pinia'
import { reactive, watch } from 'vue'
import { storageLike } from "@/store/pinia.js"
import useI18n from "@/i18n/index.js";
const { t } = useI18n.global;

export const userStore = defineStore('user', () => {
    const userInfo = reactive({});

    const setUserInfo = (val) => {
        Object.assign(userInfo, val);
    }
    const getUserInfo = () => {
        return userInfo;
    }
    const removeUserInfo = () => {
        Object.keys(userInfo).map(key => {
            userInfo[key] = null;
            delete userInfo[key];
        })
    }

    watch(
        () => userInfo,
        val => {
            if (val?.tenantName && document.title === t('otherMsg.tabTitleExtra')) {
                document.title += ` - ${val.tenantName}`
            } else {
                document.title = t('otherMsg.tabTitleExtra')
            }
        },
        { deep: true, immediate: true }
    )

    return {
        userInfo,
        setUserInfo,
        getUserInfo,
        removeUserInfo,
    }
}, {
    persist: {
        storage: storageLike
    },
})